import { buildProps } from '@sgui-plus/utils/props'
import { TreeComponentProps } from './tree.type'
import { isBool } from "@sgui-plus/utils/util"
import type { PropType } from 'vue'

export const treeProps = buildProps({
  data: {
    type: Array,
    default: () => []
  },
  showCheckbox: {
    type: Boolean,
    default: false
  },
  cascadeCheck: {
    type: Boolean,
    default: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  filterable: {
    type: Boolean,
    default: false
  },
  filterHighlight: {
    type: Boolean,
    default: true
  },
  filterPlaceholder: {
    type: String,
    default: ''
  },
  nodeKey: {
    type: String
  },
  defaultSelectedKeys: {
    type: Array,
    default: () => []
  },
  defaultCheckedKeys: {
    type: Array,
    default: () => []
  },
  defaultExpandedKeys:{
    type: Array,
    default: () => []
  },
  showMenu: {
    type: Array,
    default: () => []
  },
  showIcon: {
    type: Boolean,
    default: true
  },
  showSelectedBar: {
    type: Boolean,
    default: false
  },
  emptyText: String,
  props: {
    type: Object as PropType<TreeComponentProps['props']>,
    default: () => ({
      children: 'children',
      label: 'label'
    })
  }
})

export const treeEmits = {
  onNodeClick: (node) => true,
  onCheckChange: (node, checked: boolean) => isBool(checked),
  onNodeExpand: (node) => true,
  onNodeCollapse: (node) => true,
  onDrag: (node) => true,
  onDrop: (node, targetNode, moveType: string) => true,
  onCreated: () => true,
  onContextmenu: (node) => true
}
